<template>

<app-wrapper ref="wrapper" class="section" :class="{'is-active': seen}">

	<app-inner class="section-inner" :row="!window.is.mobile">

		<div class="section-image">

			<div class="section-image-phone" :style="{backgroundImage: 'url(' + item.image + ')'}"></div>

		</div>

		<div class="section-content">

			<div class="section-content-wrapper">

				<app-text class="section-content-text" :center="window.is.mobile" :white="isOdd" v-html="item.text" />

				<div class="section-content-buttons">
					
					<app-button to="Register/Business" :theme="(isOdd)? 'white' : 'blue'" :text="button" />

				</div>

			</div>

		</div>

	</app-inner>

</app-wrapper>

</template>

<script>

export default {

	props: ['item', 'button', 'index'],

	data: function() {

		return {
			seen: false
		}

	},
	
	computed: {

		isOdd: function() {
			
			return this.index % 2 !== 0

		}

	},

	created: function() {

		window.addEventListener('scroll', this.onScroll.bind(this))

		this.$nextTick(this.onScroll.bind(this))

	},

	beforeDestroy: function() {

		if (!this.seen) window.removeEventListener('scroll', this.onScroll.bind(this))

	},

	methods: {

		onScroll: function() {

			if (this.$refs.wrapper) {

				if (window.innerHeight * 0.75 >= this.$refs.wrapper.$el.getBoundingClientRect().top) {

					this.seen = true
					window.removeEventListener('scroll', this.onScroll.bind(this))

				}

			}

		}

	}

}

</script>

<style scoped>

.section {
	overflow: hidden;
}

.section:nth-child(odd) {
	background-color: var(--color-blue-light);
}

.is-desktop .section:nth-child(odd) .section-inner,
.is-tablet .section:nth-child(odd) .section-inner {
	flex-direction: row-reverse;
}

.is-mobile .section-inner {
	align-items: center;
}

.section-inner {
	padding: 32px 0px;
	max-width: 1024px;
}

.is-mobile .section-inner {
	padding: 20px 0px;
	max-width: 100%;
}

.section-image {
	flex-shrink: 0;
	width: 320px;
}

.is-mobile .section-image {
	width: 260px;
	margin-bottom: 40px;
}

.section-image-phone {
	width: 320px;
	opacity: 0;
	margin-left: -320px;
	height: 520px;
	background-color: #fff;
    border: 6px solid #000;
    border-radius: 16px;
    background-position: 50% 0;
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0 4px 24px 0 rgba(0,0,0,.25);
    transition: all .5s ease-in-out;
}

.is-mobile .section-image-phone {
	width: 260px;
	height: 420px;
}

.section:nth-child(odd) .section-image-phone {
	margin-left: 320px;
}

.section.is-active .section-image-phone {
	margin-left: 0px;
	opacity: 1;
}

.section-content {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
}

.section-content-wrapper {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	opacity: 0;
	transition: all .5s ease-in-out;
	margin-top: 520px;
}

.section.is-active .section-content-wrapper {
	opacity: 1;
	margin-top: 0px;
}

.section-content-text {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-bottom: 64px;
}

.is-mobile .section-content-text {
	padding-bottom: 20px;
}

.section-content-text >>> h2 {
	font-size: 48px!important;
	line-height: 48px!important;
	margin-bottom: 32px!important;
}

.is-mobile .section-content-text >>> h2 {
	font-size: 22px!important;
	line-height: 18px!important;
	margin-bottom: 20px!important;
}

.section-content-text >>> p {
	font-size: 20px!important;
	line-height: 28px!important;
}

.is-mobile .section-content-text >>> p {
	font-size: 16px!important;
	line-height: 20px!important;
}

.section:nth-child(even) .section-content {
	padding-left: 64px;
}

.section:nth-child(odd) .section-content {
	padding-right: 64px;
}

.is-mobile .section:nth-child(even) .section-content {
	padding-left: 0px;
}

.is-mobile .section:nth-child(odd) .section-content {
	padding-right: 0px;
}

.section:nth-child(even) .section-content-text >>> h2 {
	color: var(--color-blue-light)!important;
}

.section-content-buttons {
	flex-shrink: 0;
}

.is-mobile .section-content-buttons {
	display: flex;
	flex-direction: row;
	justify-content: center;
}

</style>